export default __webpack_public_path__ + "static/media/bg-header-overview.22025287.png";